<script>
import Layout from '@layouts/main'
import {AxiosHelper} from '@src/utils/utils';
import Datatable from '@components/Datatable';
import moment from 'moment';


export default {
	components: { Layout, Datatable },
  data() {
    return {
			title: '문자내역',
			tableData : [],
			applyNum : {},
			cardInfo : {
				phone : '',
				card_name : ''
			},
			cardInfos : [],

			tableOption : {
				paging : false,
				searching : false,
				lengthChange: false,
				select: {
					style: 'multi'
				},
				columns : [
					{data : 'id'},
					{data : 'subject'},
					{data : 'snippet'},
					{data : 'time'},
					{data : 'price'},
					{data : 'size'}
				],
				buttons: [
					{
						text: '전체선택',
						action: () => {
							this.tableData = this.tableData.map((v) => {
								v._selected = true;
								return v;
							})
						}
					},
					{
						text: '선택해제',
						action: () => {
							this.tableData = this.tableData.map((v) => {
								v._selected = false;
								return v;
							})
						}
					}
				],
				columnDefs : [
					{
						render : function(data, type, row) {
							return moment(data).format('YYYY.MM.DD hh:mm:ss');
						},
						targets : 3
					},
					{
						render : function(data, type, row) {
							return data == null ? '' : data;
						},
						targets : 4
					},
					{ visible : false, targets : [5]}
				]
			},

			tableOption2 : {
				paging : false,
				searching : false,
				lengthChange: false,
				columns : [
					{data : 'phone'},
					{data : 'card_name'},
				]
			},


    }
	},
	mounted() {
		// console.clear();
		this.reload();

		AxiosHelper.get('/api/cardsms/cardInfo/list').then(ret => {
			const applyNum = {};
			ret.data.forEach((data) => {
				applyNum[data.phone] = data.card_name;
			});
			this.applyNum = applyNum;
		});
	},
	methods : {
		reload : function() {
			AxiosHelper.get('/api/cardsms/smsList').then(ret => {
				this.tableData = ret.data;
			}).catch((ret) => {
				this.tableData = [];
		});
		},

		checkPayList : function() {
			const newData = this.tableData.map((item, idx) => {
				var subject = item.subject;

				if(this.applyNum[subject]) {
					const snippet = item.snippet;
					const regexp = /(?<=( |\(금액\)))[\d]+원/g;	// 금액이 있는 문자는 모두 등록 확인 대상
					const regexp1 = / [\d]+개월/g;	// 할부인지 확인
					let matched = snippet.match(regexp);

					if(matched != null) {
						item._selected = true;
						
						const money = matched[0].trim().replaceAll("원", '');
						matched = snippet.match(regexp1);
						let period = '일시불';
						if(matched != null) {
							period = matched[0].trim().replaceAll('개월', '').toInt();
						}
						
						item.price = this.applyNum[subject] + ', ' + money + ', ' + period;
					}
				}
				return item;
			});

			this.tableData = newData;
		},

		registPayList : function() {
			const list = this.tableData.filter((v, idx) => {
				return v._selected === true;
			});
			
			if(list.length === 0)
				return;
			
			AxiosHelper.post('/api/cardsms/smsList/regist', {
				list : JSON.stringify(list)
			}).then(ret => {
				for(var i = ret.data.length - 1; i >= 0; i--) {
					var data = ret.data[i];
					this.pushMessage(moment(data.time).format('YYYY.MM.DD hh:mm:ss') + ' ' + data.cardName + ' ' + data.price);
					this.reload();
				}

			});
		},

		removePayList : function() {
			const list = this.tableData.filter((v, idx) => {
				return v._selected === true;
			});

			if(list.length === 0)
				return;
		
			const promiseList = [];
			for (var i = list.length - 1; i >= 0; i--) {
				const item = list[i];
				promiseList.push(AxiosHelper.post('/api/cardsms/smsList/' + item.id + '/delete'));
			}
			
			Promise.all(promiseList).then((values) => {
				this.reload();
			});
		},

		cardRegist : function() {
			this.$refs.registModal.show();
		},
		cardRegistShown : function() {
			AxiosHelper.get('/api/cardsms/cardInfo/list').then(ret => {
				this.cardInfos = ret.data;
			});
		},

		tableClick : function(index, data, event) {
			this.tableData[index.row]._selected = !this.tableData[index.row]._selected;
		},

		registCardInfo : function() {
			AxiosHelper.post('/api/cardsms/cardInfo/regist', {
				phone : this.cardInfo.phone,
				cardName : this.cardInfo.card_name,
			}).then(ret => {
				this.cardInfo = {
					phone : '',
					card_name : ''
				};
				this.cardRegistShown();
			});
		},

	}
}
</script>

<template>
  <Layout>
    <C.PageHeader :title="title" />
    <C.Row>
			<C.Col lg="12">
				<C.Card>
					<C.CardHeader>구글 메일로 수신한 문자 중 결제 내역을 가계부에 등록한다.</C.CardHeader>
					<C.CardBody>
						<C.Row>
							<div class="button-list">
								<button type="button" class="btn btn-blue waves-effect waves-light"
									@click="checkPayList">승인문자확인</button>
								<button type="button" class="btn btn-blue waves-effect waves-light"
									@click="registPayList">승인문자등록</button>
								<button type="button" class="btn btn-danger waves-effect waves-light"
									@click="removePayList">선택항목삭제</button>
								<button type="button" class="btn btn-info waves-effect waves-light"
									@click="cardRegist">카드정보등록</button>
							</div>
						</C.Row>
						<C.Row class="mt-1">
							<Datatable :option="tableOption"
								:data="tableData"
								table-styles="font-size:12px"
								table-remove-classes='nowrap'
								@clickHandler="tableClick"
							>
								<template v-slot:thead>
									<tr>
										<th>id</th>
										<th>제목</th>
										<th>내용</th>
										<th>시간</th>
										<th>파싱</th>
										<th>size</th>
									</tr>
								</template>
							</Datatable>
						</C.Row>
					</C.CardBody>
				</C.Card>
        <!-- end card-box -->
			</C.Col>
			

    </C.Row>
    <!--- end row -->
		<C.Modal ref="registModal" title="카드정보"
			dialog-class-name="modal-dialog-scrollable"
			@shown="cardRegistShown"
		>
			<form class="form-inline">
				<div class="form-group sm-2">
					<label class="sr-only">전화번호</label>
					<input v-model="cardInfo.phone" type="text" class="form-control" placeholder="전화번호"/>
				</div>
				<div class="form-group sm-2">
					<label class="sr-only">카드명</label>
					<input v-model="cardInfo.card_name" type="text" class="form-control" placeholder="카드명"/>
				</div>
				<button type="button" class="btn btn-primary waves-effect waves-light"
					@click="registCardInfo">등록</button>
			</form>
		
			
				<Datatable 
					:option="tableOption2"
					:data="cardInfos"
				>
					<template v-slot:thead>
						<tr>
							<th>전화번호</th>
							<th>카드명</th>
						</tr>
					</template>
				</Datatable>
		</C.Modal>
  </Layout>
</template>